// Home.jsx
import React, { useRef } from 'react';
import Services from '../components/Services';
import TechnicianSlider from '../components/TechnicianSlider';
import CategoryNavigation from '../components/CategoryNavigation';
import HeroSection from '../components/HeroSection';
import './Home.css';

function Home() {
  const categoryRef = useRef(null);

  const handleSummonClick = () => {
    // Scroll to the CategoryNavigation component
    if (categoryRef.current && categoryRef.current.scrollToSection) {
      categoryRef.current.scrollToSection();
    }
  };

  return (
    <div>
      <HeroSection onSummonClick={handleSummonClick} />
      <section className="home-mobile-intro">
        <span className="home-mobile-eyebrow">OneClick • Trusted local help</span>
        <h1>What do you need help with today?</h1>
        <p>Find a verified technician for home repairs, electrical work, appliances and more.</p>
        <button type="button" onClick={handleSummonClick}>
          Explore services <span aria-hidden="true">→</span>
        </button>
        <div className="home-mobile-promise">
          <span>✓ Verified professionals</span>
          <span>⚡ Fast response</span>
        </div>
      </section>
      <CategoryNavigation ref={categoryRef} />
      <Services />
      <TechnicianSlider />
    </div>
  );
}

export default Home;